import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', redirect: '/app/home' },
    {
      path: '/app',
      redirect: '/app/home',
      name: 'App',
      component: () => import(/* webpackChunkName: "main-layout" */ '@/pages/MainLayout.vue'),
      meta: {
        requiresAuthentication: true
      },
      children: [
        {
          path: 'home',
          name: 'Home',
          component: () => import(/* webpackChunkName: "dashboard" */ '@/pages/Dashboard/Dashboard.vue')
        },
        {
          path: 'flows-live/:env',
          name: 'FlowsLive',
          component: () => import(/* webpackChunkName: "flows-live" */ '@/pages/Flows/Live/FLiveLayout.vue')
        },
        {
          path: 'flows-list',
          name: 'FlowsList',
          component: () => import(/* webpackChunkName: "flows-list" */ '@/pages/Flows/List/FListLayout.vue'),
          children: [
            {
              path: 'graph',
              name: 'Graph',
              component: () => import(/* webpackChunkName: "flows-list" */ '@/pages/Flows/List/FListLayout.vue')
            }
          ]
        },
        {
          path: 'kpi',
          component: () => import(/* webpackChunkName: "kpi" */ '@/pages/KPI/KPILayout.vue'),
          name: 'Kpi'
        },
        {
          path: 'admin/users',
          component: () => import(/* webpackChunkName: "user-management" */ '@/pages/Admin/UserManagement.vue'),
          name: 'Users'
        },
        {
          path: 'admin/roles',
          component: () => import(/* webpackChunkName: "role-management" */ '@/pages/Admin/RoleManagement.vue'),
          name: 'Roles'
        },
        {
          path: 'admin/management',
          component: () => import(/* webpackChunkName: "management" */ '@/pages/Admin/Management.vue'),
          name: 'Management'
        }
      ]
    },
    { path: '/401', component: () => import(/* webpackChunkName: "errors" */ '@/pages/Errors/401.vue') },
    { path: '/404', component: () => import(/* webpackChunkName: "errors" */ '@/pages/Errors/404.vue') },
    { path: '/disconnect', component: () => import(/* webpackChunkName: "errors" */ '@/pages/Errors/Disconnect.vue') },
    { path: '*', component: () => import(/* webpackChunkName: "errors" */ '@/pages/Errors/404.vue') }
  ]
})

export default router
